import { render, staticRenderFns } from "./BorderRecognition.vue?vue&type=template&id=d6b60294&scoped=true&lang=html&"
import script from "./BorderRecognition.vue?vue&type=script&lang=js&"
export * from "./BorderRecognition.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6b60294",
  null
  
)

export default component.exports